const resources = (() => {
    const _resources = {
        "account_info": accountInfoResource,
        "consolidated_monthly_line_item": consolidatedMonthlyLineItemResource,
        "consolidated_debt_analysis": consolidatedDebtAnalysisResource,
        "ebitda_schedule": ebitdaScheduleResource,
        "consolidated_monthly_activity": consolidatedMonthlyActivityResource,
        "consolidated_trend_analysis": consolidatedTrendAnalysisResource,
        "transactions": transactionsResource,
        "report": reportResource
    };
    _resources.init = (default_config, resource, is_show_chart = true) => {
        const resource_config = default_config.body.config[resource] || {};
        resource_config.data = default_config.bank_statement_info[resource];
        if (resource.search(/^consolidated_/gm) !== 1) resource_config["account_level"] = default_config.bank_statement_info[resource.replace(/^consolidated/, "account_level")];
        if (!!resource_config.columns && Object.keys(resource_config.columns).length > 0)
            resource_config.headers = templateUtil.getWidgetColumnsByOrder(resource_config.columns);
        resource_config.value = !!resource_config.value ? resource_config.value : resource.charAt(0).toUpperCase() + resource.slice(1).replace(/([-_][a-z])/ig, (val) => val.toUpperCase().replace('_', ' '));
        Object.assign(default_config, default_config["_" + resource]);
        _resources[resource].init(default_config, resource, resource_config);
        templates.bind_events(default_config, resource, templates[resource].main);
    };
    return _resources;
})();
